import { z } from 'zod';

import { AI_VISIBILITY_PLATFORMS } from '@brightlocal/shared';

import { UNBRANDED_PROMPT_TYPE } from './consts';

/**
 * Search params of the AI Visibility route — both Platforms-section filters.
 * An absent param means "all" (no filtering), so default URLs stay clean.
 */
export const aiVisibilitySearchSchema = z.object({
  /** Platform the overview cards are narrowed to; absent = all platforms. */
  platform: z.nativeEnum(AI_VISIBILITY_PLATFORMS).optional().catch(undefined),
  /** Prompt-type slice of the metric sets; absent = all prompts. */
  promptType: z.literal(UNBRANDED_PROMPT_TYPE).optional().catch(undefined)
});

export type AiVisibilitySearch = z.infer<typeof aiVisibilitySearchSchema>;
